import React from "react";
import { ExportButtonType } from "./types";
import { Button } from "@pickit/pickit-components";
import { useTranslation } from "react-i18next";

const ExportButton = ({ disabled, testId, onClick }: ExportButtonType) => {
  const { t } = useTranslation();
  return (
    <Button
      label={t("global:export")}
      iconName="document-download"
      onClick={onClick}
      testId={`${testId}-export-button`}
      size="medium"
      hierarchy="secondary"
      disabled={disabled}
    />
  );
};

export default ExportButton;
